// extracted by mini-css-extract-plugin
var _1 = "RentalPortalMatch-modulecell__s0ebP";
var _2 = "RentalPortalMatch-modulefitCell__TZ_wJ RentalPortalMatchFitCell-moduleRentalPortalMatchFitCell__afNH9";
export { _1 as "cell", _2 as "fitCell" }
